import { MessageAPI } from '../../lib/api';

export const RECIEVE_MESSAGES = 'MESSAGE.RECIEVE_MESSAGES';
export const RECIEVE_MESSAGE = 'MESSAGE.RECIEVE_MESSAGE';

const API = new MessageAPI();

export const getCommentsForFinding = ({ findingId, personId }) => (dispatch) => {
  API.getCommentsForFinding({ findingId, personId })
    .then(({ messages }) => dispatch({
      type: RECIEVE_MESSAGES,
      messages,
      objectId: findingId,
    }));
};

export const saveCommentForFinding = ({ body, findingId, personId }) => (dispatch) => {
  API.addCommentToFinding({ body, findingId, personId })
    .then(({ message }) => dispatch({
      type: RECIEVE_MESSAGE,
      message,
      objectId: findingId,
    }));
};



// WEBPACK FOOTER //
// ./src/redux/actions/Message.js